import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchPermissions } from "./thunks";
import { Permission } from "@/types";

interface PaginatedPermission {
  data: Permission[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface PermissionState {
  permissions: PaginatedPermission;
  loading: boolean;
  error: string | null;
}

const initialState: PermissionState = {
  permissions: { data: [] },
  loading: false,
  error: null,
};

const PermissionSlice = createSlice({
  name: "Permission",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchPermissions.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          const payload = action.payload;
          if (Array.isArray(payload.data)) {
            state.permissions = { data: payload.data };
          } else {
            state.permissions = {
              data: payload.data.data,
              total: payload.data.total,
              currentPage: payload.data.current_page,
              perPage: payload.data.per_page,
            };
          }
        },
      )
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      });
  },
});

export default PermissionSlice.reducer;
